export default __webpack_public_path__ + "static/media/planing.00727f62.svg";